import * as React from "react";
import MaskedInput from "react-text-mask";
import Customercontact from "../../interfaces/CustomerContact";

interface Props {
    contactNumber: number;
    contactData: Customercontact;
    onItemRemoved?: (contactNumber: number) => void;
    onHonorificSelected?: (contactNumber: number, honorificId: number, honorificName: string | undefined) => void;
    onNameChanged?: (contactNumber: number, name: string | undefined) => void;
    onPhoneChanged?: (contactNumber: number, phone: string | undefined) => void;
    onTitleChanged?: (contactNumber: number, title: string | undefined) => void;
    onEmailChanged?: (contactNumber: number, email: string | undefined) => void;
}

interface State {
    honorificId: number;
    contactNumber: number;
    contactData: Customercontact;
}

export default class ContactModel extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            honorificId: props.contactData !== undefined && props.contactData.honorificId !== undefined ? props.contactData.honorificId : 0,
            contactNumber: props.contactNumber,
            contactData: props.contactData
        };

        this.handleHonorificSelected = this.handleHonorificSelected.bind(this);
        this.handleNameChanged = this.handleNameChanged.bind(this);
        this.handlePhoneChanged = this.handlePhoneChanged.bind(this);
        this.handleTitleChanged = this.handleTitleChanged.bind(this);
        this.handleEmailChanged = this.handleEmailChanged.bind(this);
        this.handleRemoveContactClicked = this.handleRemoveContactClicked.bind(this);
    }

    public render() {
        return <div>
            <div className="row">
                <div className="field-group col-sm-12">

                    <span className="field-label">Contact Person</span>
                    <select name={`customerContacts[${this.state.contactNumber}][${this.state.honorificId}]`} className="form-control honorific"
                        value={this.state.honorificId} onChange={this.handleHonorificSelected}>
                        <option value="">Select</option>
                        <option value="1">Mr.</option>
                        <option value="2">Mrs.</option>
                        <option value="3">Miss</option>
                    </select>
                    <input type="text" name={`customerContacts[${this.state.contactNumber}][name]`} className="form-control contact-name"
                        value={this.state.contactData.name} required maxLength={50} onInput={e => e.currentTarget.setCustomValidity("")}
                        onInvalid={e => e.currentTarget.setCustomValidity("Contact name is required.")} onChange={this.handleNameChanged} />
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Phone</span>
                    <MaskedInput mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                        name={`customerContacts[${this.state.contactNumber}][phone]`} className="form-control" placeholder="(xxx) xxx-xxxx"
                        required onInput={e => e.currentTarget.setCustomValidity("")}
                        onInvalid={e => e.currentTarget.setCustomValidity("Phone number is required and must be in the format of (aaa) bbb-cccc.")}
                        value={this.state.contactData.phone} onChange={this.handlePhoneChanged} />
                </div>
                <div className="field-group col-sm-6">
                    <span className="field-label">Title</span>
                    <input type="text" name={`customerContacts[${this.state.contactNumber}][title]`} className="form-control" id="title"
                        value={this.state.contactData.title} maxLength={50} onChange={this.handleTitleChanged} />
                </div>
            </div>
            <div className="row">
                <div className="field-group col-sm-6">
                    <span className="field-label">Email</span>
                    <input type="email" name={`customerContacts[${this.state.contactNumber}][email]`} className="form-control" id="email"
                        value={this.state.contactData.email} maxLength={50} onChange={this.handleEmailChanged} />
                </div>
                <div className="field-group col-sm-2">
                    <a href="javascript:void(0);" onClick={this.handleRemoveContactClicked}>Remove</a>
                </div>
            </div>

        </div>;
    }

    public async componentDidUpdate(prevProps: { contactNumber: number, contactData: Customercontact }) {

        if (this.props.contactData !== undefined && prevProps.contactData.honorificId !== this.props.contactData.honorificId
            || (this.props.contactData !== undefined && prevProps.contactData.name !== this.props.contactData.name)
            || (this.props.contactData !== undefined && prevProps.contactData.phone !== this.props.contactData.phone)
            || (this.props.contactData !== undefined && prevProps.contactData.title !== this.props.contactData.title)
            || (this.props.contactData !== undefined && prevProps.contactData.email !== this.props.contactData.email)) {

            this.setState({
                honorificId: this.props.contactData !== undefined && this.props.contactData.honorificId !== undefined ? this.props.contactData.honorificId : 0,
                contactNumber: this.props.contactNumber,
                contactData: this.props.contactData
            });
        }
    }

    private handleHonorificSelected(e: React.ChangeEvent<HTMLSelectElement>) {
        if (e.target !== null && e.target.value !== undefined) {
            this.setState({
                honorificId: parseInt(e.target.value.toString())
            });

            let label = "";
            let index = e.nativeEvent !== null && e.nativeEvent.target !== null ? (e.nativeEvent.target as HTMLSelectElement).selectedIndex : -1;

            if (index > 0) {
                label = e.nativeEvent !== null && e.nativeEvent.target !== null ? ((e.nativeEvent.target as HTMLSelectElement)[index] as HTMLOptionElement).text : "";
            }
            if (this.props.onHonorificSelected !== undefined) {
                this.props.onHonorificSelected!(this.props.contactNumber, parseInt(e.target.value.toString()), label);
            }
        }
    }

    private handleNameChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target !== null && e.target.value !== undefined) {
            if (this.props.onNameChanged !== undefined) {
                this.props.onNameChanged!(this.props.contactNumber, e.target.value);
            }
        }
    }

    private handlePhoneChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target !== null && e.target.value !== undefined) {
            if (this.props.onPhoneChanged !== undefined) {
                this.props.onPhoneChanged!(this.props.contactNumber, e.target.value);
            }
        }
    }

    private handleTitleChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target !== null && e.target.value !== undefined) {
            if (this.props.onTitleChanged !== undefined) {
                this.props.onTitleChanged!(this.props.contactNumber, e.target.value);
            }
        }
    }

    private handleEmailChanged(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target !== null && e.target.value !== undefined) {
            if (this.props.onEmailChanged !== undefined) {
                this.props.onEmailChanged!(this.props.contactNumber, e.target.value);
            }
        }
    }

    private handleRemoveContactClicked(e: React.MouseEvent<HTMLAnchorElement>) {
        if (this.props.onItemRemoved !== undefined) {
            this.props.onItemRemoved!(this.state.contactNumber);
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/common/ContactModel.tsx